import React, { useState } from 'react';
import TopBar from '../../../components/TopBar';
import Header from '../../../components/headerfooter/Header';
import Footer from '../../../components/headerfooter/Footer';
import CallToAction from '../../../components/home/CallToAction';
import PageBanner from '../../../components/PageBanner';
import { MdBookmark } from "react-icons/md";
import { AiOutlineLink } from "react-icons/ai";
import { Link } from "react-router";
import { MdVerified, MdFilterList } from "react-icons/md";
import { FaStar, FaRegStar, FaFire, FaRocket,  } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";

const DesignGenerators = () => {
    const [activeTab, setActiveTab] = useState("Trending");
    const [showVerifiedOnly, setShowVerifiedOnly] = useState(false);

    const [showFilterModal, setShowFilterModal] = useState(false);
    // const [showVerifiedOnly, setShowVerifiedOnly] = useState(false);

    const handleFilterClick = () => {
        setShowFilterModal(true);
    };

    const handleCloseModal = () => {
        setShowFilterModal(false);
    };

    const tools = [
        {
            name: "Brandblast.ai",
            logo: "https://cdn2.futurepedia.io/1018ee2fe376d7dd598ca2576d7fc6ebb2c1f797-128x128.png",
            link: "#",
            rating: 4,
            category: "Trending", // New category for filtering
            verified: true,
        },
        {
            name: "Brandblast.ai",
            logo: "https://cdn2.futurepedia.io/1018ee2fe376d7dd598ca2576d7fc6ebb2c1f797-128x128.png",
            link: "#",
            rating: 4,
            category: "Trending", // New category for filtering
            verified: false,
        },
        {
            name: "Brandblast.ai",
            logo: "https://cdn2.futurepedia.io/1018ee2fe376d7dd598ca2576d7fc6ebb2c1f797-128x128.png",
            link: "#",
            rating: 4,
            category: "Trending", // New category for filtering
            verified: true,
        },
        {
            name: "Brandblast.ai",
            logo: "https://cdn2.futurepedia.io/1018ee2fe376d7dd598ca2576d7fc6ebb2c1f797-128x128.png",
            link: "#",
            rating: 4,
            category: "Trending", // New category for filtering
            verified: false,
        },
        {
            name: "Brandblast.ai",
            logo: "https://cdn2.futurepedia.io/1018ee2fe376d7dd598ca2576d7fc6ebb2c1f797-128x128.png",
            link: "#",
            rating: 4,
            category: "Trending", // New category for filtering
            verified: true,
        },
        {
            name: "SocialBoost",
            logo: "https://via.placeholder.com/60",
            link: "#",
            rating: 5,
            category: "Popular",
            verified: false,
        },
        {
            name: "SocialBoost",
            logo: "https://via.placeholder.com/60",
            link: "#",
            rating: 5,
            category: "Popular",
            verified: false,
        },
        {
            name: "SocialBoost",
            logo: "https://via.placeholder.com/60",
            link: "#",
            rating: 5,
            category: "Popular",
            verified: true,
        },
        {
            name: "SocialBoost",
            logo: "https://via.placeholder.com/60",
            link: "#",
            rating: 5,
            category: "Popular",
            verified: true,
        },
        {
            name: "CreativeGen",
            logo: "https://via.placeholder.com/60",
            link: "#",
            rating: 3,
            category: "New",
            verified: false,
        },
        {
            name: "CreativeGen",
            logo: "https://via.placeholder.com/60",
            link: "#",
            rating: 3,
            category: "New",
            verified: false,
        },
        {
            name: "CreativeGen",
            logo: "https://via.placeholder.com/60",
            link: "#",
            rating: 3,
            category: "New",
            verified: true,
        },
        {
            name: "CreativeGen",
            logo: "https://via.placeholder.com/60",
            link: "#",
            rating: 3,
            category: "New",
            verified: false,
        },
        {
            name: "Designify",
            logo: "https://via.placeholder.com/60",
            link: "#",
            rating: 4,
            category: "Trending",
            verified: false,
        },
        {
            name: "Brandify",
            logo: "https://via.placeholder.com/60",
            link: "#",
            rating: 5,
            category: "Popular",
            verified: true,
        },
        {
            name: "Brandblast.ai",
            logo: "https://cdn2.futurepedia.io/1018ee2fe376d7dd598ca2576d7fc6ebb2c1f797-128x128.png",
            link: "#",
            rating: 4,
            category: "Trending",
            verified: true,
        },
        {
            name: "SocialBoost",
            logo: "https://via.placeholder.com/60",
            link: "#",
            rating: 5,
            category: "Popular",
            verified: false,
        },
        {
            name: "CreativeGen",
            logo: "https://via.placeholder.com/60",
            link: "#",
            rating: 3,
            category: "New",
            verified: true,
        },
        {
            name: "Designify",
            logo: "https://via.placeholder.com/60",
            link: "#",
            rating: 4,
            category: "Trending",
            verified: false,
        },
    ];

    // const filteredTools = tools.filter(tool => tool.category === activeTab);
    const filteredTools = tools.filter(
        (tool) =>
            tool.category === activeTab && (!showVerifiedOnly || tool.verified)
    );

    return (
        <>
            <TopBar />
            <Header />
            <PageBanner title="Best AI Design Generators Tools" para="AI design generators make creating visuals quick and easy for everyone." />
            
            {/* Tabs and Buttons */}
            <section className="bg-background-back1 pt-16">
                <div className="flex flex-wrap justify-between items-center px-4 py-4 max-w-[80rem] mx-auto gap-4">
                    {/* Tabs */}
                    <div className="flex flex-wrap gap-0 order-2 sm:order-1">
                        {[
                            { name: "Trending", icon: <FaFire className="h-4 w-4 text-red-500" /> },
                            { name: "Popular", icon: <FaStar className="h-4 w-4 text-yellow-500" /> },
                            { name: "New", icon: <FaRocket className="h-4 w-4 text-blue-500" /> },
                        ].map((tab) => (
                            <button
                                key={tab.name}
                                className={`px-4 py-2 rounded flex items-center gap-2 ${
                                    activeTab === tab.name
                                        ? "border-2 border-customBlue text-white"
                                        : "border-2 border-transparent text-white"
                                }`}
                                onClick={() => setActiveTab(tab.name)}
                            >
                                {tab.icon}
                                {tab.name}
                            </button>
                        ))}
                    </div>

                    {/* Buttons */}
                    <div className='order-1 sm:order-2'>
                        {/* Filter and Verified Buttons */}
                        <div className="flex gap-4 text-[15px] ">
                            <button
                                onClick={handleFilterClick}
                                className="px-4 py-2 rounded border-2 border-customBlue hover:bg-background-primary transition text-white font-bold flex items-center gap-2"
                            >
                                <MdFilterList className="text-blue-500 h-5 w-5" />
                                Filter
                            </button>
                            <button
                                className={`px-4 py-2 rounded border-2 ${
                                    showVerifiedOnly
                                        ? "bg-background-primary text-white border-customBlue"
                                        : "border-customBlue"
                                } hover:bg-background-primary transition text-white font-bold flex items-center gap-2`}
                                onClick={() => setShowVerifiedOnly(!showVerifiedOnly)}
                            >
                                <MdVerified className="text-blue-500 h-5 w-5" />
                                Verified
                            </button>
                        </div>

                        {/* Filter Modal */}
                        {showFilterModal && (
                            <div
                                role="dialog"
                                aria-labelledby="filter-modal-title"
                                aria-describedby="filter-modal-description"
                                className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-85 "
                            >
                                <div
                                    className="relative w-full max-w-lg p-6 bg-background-back2 rounded-lg shadow-lg sm:max-w-md border-2 border-customBlue"
                                >
                                    {/* Modal Header */}
                                    <div className="flex justify-between items-center border-b border-gray-800 pb-3 mb-5">
                                        <h2
                                            id="filter-modal-title"
                                            className="text-xl font-semibold text-white"
                                        >
                                            Apply Filters
                                        </h2>
                                        <button
                                            type="button"
                                            onClick={handleCloseModal}
                                            className="p-2 text-gray-500 hover:text-white focus:outline-none"
                                        >
                                            <RxCross2 className="h-6 w-6" />
                                            <span className="sr-only">Close</span>
                                        </button>
                                    </div>

                                    {/* Modal Body */}
                                    <div className="space-y-4">
                                        <p
                                            id="filter-modal-description"
                                            className="text-sm text-gray-300"
                                        >
                                            Select the filters you want to apply to your search.
                                        </p>
                                        <form>
                                            <h3 className="text-lg font-semibold text-white">
                                                Features
                                            </h3>
                                            <div className="grid grid-cols-2 gap-4 mt-2">
                                                {/* Example Filter Options */}
                                                <div className="flex items-center">
                                                    <input
                                                        type="checkbox"
                                                        id="Waitlist"
                                                        name="Waitlist"
                                                        className="h-4 w-4 rounded border-gray-300"
                                                    />
                                                    <label
                                                        htmlFor="Waitlist"
                                                        className="ml-2 text-sm font-medium text-gray-300"
                                                    >
                                                        Waitlist
                                                    </label>
                                                </div>
                                                <div className="flex items-center">
                                                    <input
                                                        type="checkbox"
                                                        id="OpenSource"
                                                        name="OpenSource"
                                                        className="h-4 w-4 rounded border-gray-300"
                                                    />
                                                    <label
                                                        htmlFor="OpenSource"
                                                        className="ml-2 text-sm font-medium text-gray-300"
                                                    >
                                                        Open Source
                                                    </label>
                                                </div>
                                                {/* Add more filter options here */}
                                            </div>
                                        </form>
                                    </div>

                                    {/* Modal Footer */}
                                    <div className="flex items-center justify-end mt-8 gap-3 ">
                                        <button
                                            onClick={handleCloseModal}
                                            className="px-2 py-2 w-full rounded border-2 border-customBlue bg-background-primary hover:bg-background-btn transition text-white font-bold"
                                        >
                                            Clear Filters
                                        </button>
                                        <button
                                            className="px-2 py-2 w-full rounded border-2 border-customBlue hover:bg-background-primary transition text-white font-bold"
                                        >
                                            Apply Filters
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>
            {/* Tools Display */}
            <section className="mx-auto flex w-full flex-col items-center justify-center gap-4 font-sans bg-background-back1 pb-16">
                <div className="mx-auto grid max-w-[80rem] px-4 grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
                    {filteredTools.map((tool, index) => (
                        <div
                            key={index}
                            className="flex flex-col border-2 border-customGray hover:border-customBlue bg-background-back2 text-card-foreground h-full w-full rounded-xl"
                        >
                            <div className="relative px-6 pb-2 pt-4 flex h-24 items-start gap-4">
                                <Link to={tool.link}>
                                    <div className="relative flex h-[60px] w-[60px] flex-shrink-0 rounded-xl border">
                                        <img
                                            alt={`${tool.name} logo`}
                                            src={tool.logo}
                                            className="aspect-square h-[60px] w-[60px] rounded-xl"
                                        />
                                        {tool.verified && (
                                            <MdVerified className="absolute -top-2 -right-2 bg-white text-blue-500 rounded-full h-5 w-5" />
                                        )}
                                    </div>
                                </Link>
                                <div>
                                    <h2 className="text-lg font-bold text-white">{tool.name}</h2>
                                    <div className="flex items-center gap-1 text-yellow-500">
                                        {Array.from({ length: 5 }, (_, i) => (
                                            i < tool.rating ? (
                                                <FaStar key={i} className="h-4 w-4 text-yellow-500" />
                                            ) : (
                                                <FaRegStar key={i} className="h-4 w-4 text-gray-300" />
                                            )
                                        ))}
                                        <span className="text-gray-300 ml-2">({tool.rating})</span>
                                    </div>
                                </div>
                            </div>
                            <div className="px-6">
                                <div className="flex justify-between text-lg text-white">
                                    <span>Paid</span>
                                    <Link to="#">
                                        <span className="flex items-center text-slate-500">
                                            <span className="mr-1">10</span>
                                            <MdBookmark className="text-gray-300 hover:text-primary pointer h-5 w-5" />
                                        </span>
                                    </Link>
                                </div>
                            </div>
                            <p className="text-gray-300 my-2 line-clamp-2 overflow-hidden overflow-ellipsis px-6 text-base">
                                Automate, schedule, and optimize brand-specific social content.
                            </p>
                            <div className="px-6 mb-6 flex flex-wrap gap-1 py-2 text-base text-ice-500">
                                <Link className="hover:text-underline text-primary" to="#">
                                    #marketing 
                                </Link>
                                <Link className="hover:text-underline text-primary" to="#">
                                    #social media
                                    
                                </Link>
                                <Link className="hover:text-underline text-primary" to="#">
                                    
                                    #copywriting
                                </Link>
                            </div>
                            <div className="px-6 mt-auto flex items-center justify-between pb-4">
                                <div className="tool-label flex items-center gap-2 text-[#6b7280] ">
                                    <FaStar className="h-5 w-5 text-yellow-500" />
                                    <span className="mt-[4px]">Featured</span>
                                </div>
                                <Link
                                    rel="nofollow"
                                    target="_blank"
                                    className="hover:no-underline"
                                    to="#"
                                >
                                    <button className=" border-2 border-customBlue flex text-white px-4 py-2 rounded hover:bg-background-primary transition text-[15px] font-bold uppercase">
                                    <span className="mr-2">Visit</span>
                                    <AiOutlineLink className="h-5 w-5" />
                                    </button>
                                </Link>
                            </div>
                            
                        </div>
                    ))}
                </div>
            </section>
            <CallToAction />
            <Footer />
        </>
    );
};

export default DesignGenerators;
